<template>
    <div class="coin" :class="{'is-animate': isAnimate}" :style="`font-size: ${size}em`">
        <div class="coin__front">
            <div class="coin__inner"></div>
        </div>
        <div class="coin__edge">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
        <div class="coin__back">
            <div class="coin__inner"></div>
        </div>
        <div class="coin__shadow" v-if="isShadow"></div>
    </div>
</template>

<script>
export default {
    name: "coin",

    props: {
        size: {
            type: String,
            default: '10'
        },
        isShadow: {
            type: Boolean,
            default: false
        },
        isAnimate: {
            type: Boolean,
            default: true,
        }
    }
};
</script>

<style lang="scss" scoped>
$coin-diameter: 1em;
$coin-thickness: $coin-diameter / 10;
$coin-color: #fdda51;
$edge-faces: 80;
$edge-face-length: 3.14 * $coin-diameter/$edge-faces;
$turn-time: 1.5s;
$coin-front: "../assets/logo.png";
$coin-back: "../assets/logo.png";

.coin {
    position: relative;
    width: $coin-diameter;
    height: $coin-diameter;
    margin: 50px auto;
    transform-style: preserve-3d;
    transition: all .3s;

    &.is-animate {
        animation: rotate3d $turn-time linear infinite;

        .coin__front,
        .coin__back {
            &::after {
                animation: shine linear $turn-time/2 infinite;
            }
        }
    }
}

.coin__front,
.coin__back {
    position: absolute;
    width: $coin-diameter;
    height: $coin-diameter;
    border-radius: 50%;
    overflow: hidden;
    background: linear-gradient(90deg, #fdda51 0%, #fca741 100%);
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:after {
        content: "";
        position: absolute;
        left: -$coin-diameter/2;
        bottom: 100%;
        display: block;
        height: $coin-diameter/1.5;
        width: $coin-diameter*2;
        background: #fff;
        opacity: 0.3;
    }

    .coin__inner {
        background: linear-gradient(90deg, #fdda51 0%, #fca741 100%);
        box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        width: $coin-diameter - ($coin-diameter / 5.5);
        height: $coin-diameter - ($coin-diameter / 5.5);
        background-size: 90%;
        background-repeat: no-repeat;
        background-position: center;
    }
}

.coin__front {
    transform: translateZ($coin-thickness/2);

    .coin__inner {
        background-image: url($coin-front);
    }
}
.coin__back {
    transform: translateZ(-$coin-thickness/2) rotateY(180deg);

    .coin__inner {
        background-image: url($coin-back);
    }
}

.coin__edge {
	-webkit-transform-style: preserve-3d;
    -webkit-backface-visibility: hidden;

    @for $i from 1 through $edge-faces {
        div:nth-child(#{$i}) {
            position: absolute;
            height: $edge-face-length;
            width: $coin-thickness;
            background: darken( $coin-color, ( ($i - $edge-faces/2) * ($i - $edge-faces/2)) / ($edge-faces*$edge-faces/4) * 100 * 0.7 );
            transform:
                translateY(#{$coin-diameter/2-$edge-face-length/2})
                translateX(#{$coin-diameter/2-$coin-thickness/2})
                rotateZ(360deg/$edge-faces*$i+90)
                translateX(#{$coin-diameter/2})
                rotateY(90deg);
        }
    }
}

.coin__shadow {
    position: absolute;
    width: $coin-diameter;
    height: $coin-thickness;
    border-radius: 50%;
    background: #000;
    box-shadow: 0 0 $coin-thickness*5 $coin-thickness*5 #000;
    opacity: 0.125;
    transform: rotateX(90deg) translateZ(-$coin-diameter*1.1) scale(.5);
}

@keyframes shine {
    0%,
    15% {
        transform: translateY($coin-diameter * 2) rotate(-40deg);
    }
    50% {
        transform: translateY(-$coin-diameter) rotate(-40deg);
    }
}

@keyframes rotate3d {
    0% {
        transform: perspective(1000px) rotateY(0deg);
    }

    100% {
        transform: perspective(1000px) rotateY(360deg);
    }
}
</style>